import { ESTRATEGIA_EJEMPLO } from "./datos/ejemplo";

/**
 * Estrategia de contenido: la estructura que la marca está siguiendo hoy, con
 * el estado real de cada slot superpuesto sobre lo declarado. Un slot vacío no
 * se oculta — se muestra como hueco, con borde punteado y el motivo en rojo,
 * porque un hueco sin cubrir es justamente lo que esta pantalla existe para
 * mostrar.
 *
 * Es la segunda pestaña de "Análisis de datos" (`AnalisisDatosPage`), no una
 * pantalla suelta: el padding, el banner de vista de ejemplo y el `h1` los pone
 * el contenedor. El nombre de la estrategia queda como `h2` del panel (es el
 * sujeto de todo lo de abajo) y las secciones bajan a `h3` para colgar de él.
 */

const claseChipProcedencia = "rounded-full py-1.5 px-3 text-[12px] font-medium bg-[#DDEFE7] text-[#1D7A57]";
const claseChipMetadato =
  "rounded-full bg-[rgb(var(--brand-black-rgb)_/_0.05)] py-1.5 px-3 text-[12px] font-medium text-[rgb(var(--brand-black-rgb)_/_0.65)]";

export const EstrategiaPage = () => {
  const estrategia = ESTRATEGIA_EJEMPLO;

  return (
    <div>
      <div>
        <h2 className="text-[16px] font-semibold text-brand-black">{estrategia.nombre}</h2>
        <p className="mt-1 text-[13px] text-[rgb(var(--brand-black-rgb)_/_0.55)]">La estructura que estás siguiendo</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          <span className={claseChipProcedencia}>
            {estrategia.procedencia === "verificada" ? "Verificada por Atlas" : estrategia.procedencia}
          </span>
          <span className={claseChipMetadato}>{estrategia.rango}</span>
          <span className={claseChipMetadato}>En uso hace {estrategia.en_uso_dias} días</span>
        </div>
      </div>

      <div className="mt-8">
        <h3 className="text-[14px] font-semibold text-brand-black">Estructura de slots</h3>
        <div className="mt-3 grid grid-cols-3 gap-3">
          {estrategia.slots.map((slot) => (
            <div
              key={slot.funcion}
              className={
                slot.vacio
                  ? "rounded-2xl border border-dashed border-[rgb(var(--brand-black-rgb)_/_0.18)] p-4"
                  : "rounded-2xl border border-[rgb(var(--brand-black-rgb)_/_0.08)] bg-white p-4"
              }
            >
              <p className="text-[11px] font-medium uppercase tracking-wide text-[rgb(var(--brand-black-rgb)_/_0.5)]">
                {slot.funcion}
              </p>
              {slot.vacio ? (
                <p className="mt-1.5 text-[12px] font-medium text-[#C33B36]">{slot.estado}</p>
              ) : (
                <>
                  <p className="mt-1.5 text-[13px] font-semibold text-brand-black">{slot.quien}</p>
                  <p className="mt-0.5 text-[12px] text-[rgb(var(--brand-black-rgb)_/_0.55)]">{slot.estado}</p>
                </>
              )}
            </div>
          ))}
        </div>

        {estrategia.fuera_de_estructura && (
          <p className="mt-3 text-[12px] text-[rgb(var(--brand-black-rgb)_/_0.55)]">
            Fuera de estructura: {estrategia.fuera_de_estructura}
          </p>
        )}
      </div>

      <div className="mt-8 grid grid-cols-2 gap-6">
        <div className="rounded-2xl border border-[rgb(var(--brand-black-rgb)_/_0.08)] bg-white p-4">
          <h3 className="text-[14px] font-semibold text-brand-black">Reglas de decisión</h3>
          <div className="mt-3 flex flex-col gap-3">
            {estrategia.reglas.map((regla) => (
              <div key={regla.nombre} className="flex gap-3 border-b border-[rgb(var(--brand-black-rgb)_/_0.06)] pb-3 last:border-0 last:pb-0">
                <span className="w-24 shrink-0 text-[11px] font-semibold uppercase tracking-wide text-[rgb(var(--brand-black-rgb)_/_0.5)]">
                  {regla.nombre}
                </span>
                <span className="text-[13px] text-[rgb(var(--brand-black-rgb)_/_0.75)]">{regla.texto}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-2xl border border-[rgb(var(--brand-black-rgb)_/_0.08)] bg-white p-4">
          <h3 className="text-[14px] font-semibold text-brand-black">Por qué funciona</h3>
          <ul className="mt-3 flex flex-col gap-2.5">
            {estrategia.por_que_funciona.map((razon) => (
              <li key={razon} className="flex gap-2 text-[13px] leading-relaxed text-[rgb(var(--brand-black-rgb)_/_0.75)]">
                <span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-brand-primary" aria-hidden="true" />
                {razon}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EstrategiaPage;
